<template>
  <div class="vx-list" name="vx-list">
    <van-pull-refresh
      class="vx-list-scroller"
      ref="vpr"
      v-model="refreshing"
      @refresh="onRefresh"
      :disabled="!enable"
    >
      <van-list
        class="vlist"
        v-model="loading"
        :offset="200"
        :finished="finished"
        :finished-text="totalPage == 0 ? '' : '没有更多了'"
        :error.sync="error"
        error-text="请求失败，点击重新加载"
        @load="onLoad"
      >
        <slot></slot>

        <template #loading>
          <div v-if="refreshing"></div>
          <van-loading type="circular" size="20" v-else>加载中...</van-loading>
        </template>
      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script>
export default {
  props: {
    // 要请求的接口
    api: {
      type: Function,
    },
    // 请求时需要传的参数
    params: {
      type: Object,
    },
    // 每页请求的数量
    pageSize: {
      type: Number,
      default: 10,
    },
    // 是否开启下拉刷新
    enable: {
      type: Boolean,
      default: false,
    },
    // 手动调用刷新方法时，是否自动滚动到顶部
    enableAutoScrollTop: {
      type: Boolean,
      default: true,
    },
    firstShowLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      page: {
        pageNum: 1,
        pageSize: this.pageSize,
      },
      list: [],
      totalPage: 0,
      // 是否正在拉取某一页数据数据
      loading: false,
      // 是否已拉取所有数据
      finished: false,
      // 是否正在下拉刷新
      refreshing: false,
      error: false,
    };
  },
  computed: {
    watchData() {
      return {
        api: this.api,
        params: this.params,
      };
    },
  },
  methods: {
    async onLoad(pageObj) {
      if (this._rq) {
        this._rq.cancel('cancle');
      }
      this.loading = true;
      this.$emit('loading');
      this._rq = this.api({
        ...this.params,
        page: pageObj || this.page,
      });

      if (this.firstShowLoading && this.page.pageNum === 1) {
        this.showLoading();
      }

      this._rq
        .then(res => {
          if (res.code == 200) {
            // 请求成功后清空上一个出错的状态
            this.error = false;
            if (!pageObj) {
              if (this.page.pageNum === 1) {
                // 将滚动条重置到顶部
                this.enableAutoScrollTop && (this.$refs.vpr.$el.scrollTop = 0);
                this.list = [];
              }
              Array.isArray(res.data) && this.list.push(...res.data);

              if (res.page) {
                this.totalPage = res.page.totalPage;
              }
              if (!res.page || this.page.pageNum >= res.page.totalPage) {
                this.finished = true;
              }

              !this.finished && (this.page.pageNum += 1);
            } else {
              this.list = [];
              Array.isArray(res.data) && this.list.push(...res.data);
            }
          } else {
            this.error = true;
          }
          this.$emit('load', this.list, res);
        })
        .catch(err => {
          this.error = err && err.msg === 'cancle' ? false : true;
          // this.error = true;
          this.$emit('loadError');

          // 将下拉导致的刷新状态还原
          this.refreshing = false;
        })
        .finally(() => {
          this.loading = false;
          if (this.firstShowLoading) {
            vant.Toast.clear();
          }
        });

      return this._rq;
    },
    // 重新加载数据
    async refresh() {
      // 重置页码为初始状态
      this.page.pageNum = 1;
      // 将 finished 设置为 false，表示列表数据还未加载完
      this.finished = false;
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      // 重置错误标识
      this.error = false;

      return await this.onLoad();
    },
    async onRefresh() {
      this.$emit('refresh');
      await this.refresh();
      // 将下拉导致的刷新状态还原
      this.refreshing = false;
    },
    // 保持现有页数及当前滚动条位置，进行刷新
    async hightReFresh() {
      // 重置错误标识
      this.error = false;

      // 处理下拉刷新在hightReFresh方法调用之前，导致pageSize为0，查了所有数据的情况（网络情况不好的情况下：订单列表取消订单&&同时进行了下拉刷新）
      let tempNum = (this.page.pageNum - 1 > 0) ? this.page.pageNum - 1 : this.page.pageNum;
      let ps = this.pageSize * tempNum;
      // let ps = this.pageSize * (this.page.pageNum - 1);
      if (this.finished) {
        ps = this.pageSize * this.page.pageNum;
      }

      return await this.onLoad({
        pageNum: 1,
        pageSize: ps,
      });
    },
  },
  watch: {
    watchData: {
      deep: true,
      handler: function (nv, ov) {
        this.refresh();
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.vx-list {
  position: relative;
  z-index: 1;
}
.vx-list-scroller {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow-y: auto;
  .vlist {
    overflow: hidden;
  }
}
</style>
